import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";

function Submenu({ children, icon, title, keyEn, sidebar }) {
  const [toggleMenuItem, setToggleMenuItem] = useState(null);
  const togleMenuItemHandler = (keyEn) => {
    setToggleMenuItem((prev) =>
      prev === keyEn ? null : keyEn
    );
  };


  return (
    <li
      style={{
        background:
          toggleMenuItem === keyEn ? "rgba(33, 150, 243, 0.2)" : "transparent",
        width: "100%",
      }}
      className={`new-submenu ${toggleMenuItem === keyEn ? "open" : ""}`}
    >
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        {icon}
        {sidebar && (
          <Button
            id={keyEn}
            onClick={() => togleMenuItemHandler(keyEn)}
            className="new-submenu-button"
          > 
            {title}
          </Button>
        )}

        
        {sidebar && (
          <span
            className={`menusidebar-icon ${
              toggleMenuItem === keyEn ? "open" : ""
            }`}
          ></span>
        )}
      </div>
      <ul
        className={`animations-submenu ${
          toggleMenuItem === keyEn ? "visible" : "hidden"
        }`}
      >
        {sidebar && toggleMenuItem === keyEn ? children : null}
      </ul>
    </li>
  );
}

export default Submenu;
